import React from "react";
import "../../css/HighSchoolSection.css";
import { Link } from "react-router-dom";
import SchoolHero from "./SchoolHero";
import ParentTestimonials from "../ParentTestimonials";
import WhyChooseUs from "../WhyChooseUs";

const HighSchoolSection = () => {
  const highSchoolImg = "./images/h.jpeg";

  return (
    <>
      <SchoolHero
        title="High School"
        subtitle="Building strong foundations for lifelong learning."
        image="/images/Education_Funds4.png"
      />

      <section className="high-school-container">
        <div className="hs-main-card">
          <div className="hs-flex-layout">
            {}
            <div className="hs-image-box">
              <img
                src={highSchoolImg}
                alt="High School Students"
                className="hs-hero-img"
              />
            </div>

            {}
            <div className="hs-info-box">
              <div className="hs-dark-header">
                <h2>Higher Secondary School (UnderProcess)</h2>
              </div>

              <div className="hs-content-body">
                <div className="hs-meta">
                  <span className="hs-grade">
                    <strong>Grade 11 to 12</strong>
                  </span>
                  <span className="hs-status">
                    {" "}
                    <i className="hs-check">✔</i> Enrolling Now
                  </span>
                </div>

                <p className="hs-desc-text">
                  Our SEEB programme from Grade 1 to 12 is a comprehensive
                  curriculum which stresses on academic rigour within an
                  environment.
                  <br />
                  <br />
                  An interdisciplinary teaching at{" "}
                  <span className="hs-link">Sahara</span> gives students a
                  powerful opportunity to apply knowledge, principles, and
                  values to more than one academic subject simultaneously.
                  SEEB's global curriculum comprises built-in activities and
                  exercises which promote cross- curricular learning.
                </p>
              </div>

              {}
              <div className="hs-bottom-nav">
                <div className="hs-nav-item">
                  <Link to="/book-meeting">🤝 BOOK A MEETING</Link>
                </div>

                <div className="hs-nav-item">
                  <Link to="/admissionenquiryform">📄 ADMISSION FORM</Link>
                </div>

                <div className="hs-nav-item">
                  <Link to="/feestructure">💵 FEES</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <ParentTestimonials />
      <WhyChooseUs />
    </>
  );
};

export default HighSchoolSection;
